import styled from 'styled-components';

import { mediaQueries } from '../../../../utils/styles';

export const WhiteBackground = styled.div`
  background-color: white;
`;

export const Header = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 82px;
  margin: 0;
  padding: 27px 0;
`;

export const Title = styled.h1`
  font-family: 'RobotoCondensedLight';
  font-size: 32px;
  line-height: 1.4;
  letter-spacing: 0.2px;
  color: #071743;
  margin: 0;
  text-align: center;
  ${mediaQueries.xs(`
    margin-bottom: 10px;
  `)};
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/PaperHeader/styled-components.js